import {Injectable} from '@angular/core';
import {GoogleMapsAPIWrapper} from '@agm/core';
import {NgZone} from '@angular/core';
import {MapsAPILoader} from '@agm/core';
import {Router} from '@angular/router';

declare let google: any;


@Injectable()
export class CustomGoogleMapsAPIWrapper {
  public _map: Promise<google.maps.Map>;
  public _mapResolver: (value?: google.maps.Map) => void;

  constructor(private _loader: MapsAPILoader, private _zone: NgZone, private apiWrapper: GoogleMapsAPIWrapper, private router: Router) {
    this._map =
      new Promise<google.maps.Map>((resolve: () => void) => {
        this._mapResolver = resolve;
      });
  }

  createMap(el: HTMLElement, mapOptions: google.maps.MapOptions): Promise<void> {
    return this.apiWrapper.createMap.call(this, el, mapOptions);
  }

  fitBounds(latLng: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral): Promise<void> {
    return this.apiWrapper.fitBounds.call(this, latLng);
  }

  getNativeMap(): Promise<google.maps.Map> {
    return this.apiWrapper.getNativeMap.call(this);
  }

  createMarker(options: any, addToMap: boolean = true):
    Promise<google.maps.Marker> {
    return this._map.then((map: google.maps.Map) => {
      if (addToMap) {
        options.map = map;
      }
      const marker = new google.maps.Marker(options);

      // InfoWindows
      const infowindow = new google.maps.InfoWindow({
        content: options.projectData.name
      });
      marker.addListener('mouseover', () => infowindow.open(map, marker));
      marker.addListener('mouseout', () => infowindow.close(map, marker));

      // Redirection to project's page on click
      marker.addListener('click', () => this._zone.run(() => this.router.navigate(['safe', options.projectData.id])));

      return marker;
    });
  }

  setZoom(zoom: number): Promise<void> {
    return this.apiWrapper.setZoom.call(this, zoom);
  }


  setCenter(latLng: google.maps.LatLngLiteral): Promise<void> {
    return this.apiWrapper.setCenter.call(this, latLng);
  }

}
